export default function any(iterable, predicate) {
    for (const item of iterable) {
        if (!predicate || predicate(item)) {
            return true;
        }
    }
    return false;
}
